/* eslint-disable max-len */

import React from 'react';

export default function RiskIcon(props) {
  return (
    <svg viewBox="0 0 35 34" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fillRule="nonzero">
        <path d="M17.102 8.75c-.878 0-1.59.942-1.59 2.104v7.574c0 1.162.712 2.104 1.59 2.104.879 0 1.591-.942 1.591-2.104v-7.574c0-1.162-.712-2.104-1.59-2.104zM17.102 21.875a1.59 1.59 0 0 0-1.59 1.59v.084a1.59 1.59 0 0 0 3.181 0v-.096a1.59 1.59 0 0 0-1.59-1.578z"/><path d="M24.69.399H10.108c-1.342 0-2.43 1.067-2.43 2.383v4.766H2.814c-1.342 0-2.43 1.067-2.43 2.383v14.298c0 1.316 1.088 2.383 2.43 2.383h4.861v4.766c0 1.316 1.089 2.383 2.43 2.383h14.585c1.342 0 2.43-1.067 2.43-2.383v-4.766h4.862c1.342 0 2.43-1.067 2.43-2.383V9.93c0-1.316-1.088-2.383-2.43-2.383H27.12V2.782c0-1.316-1.088-2.383-2.43-2.383zm8.01 8.454v16.503h-6.122l-.808.778v6.02H9.023v-6.02l-.808-.778H2.094V8.853h6.12l.809-.778v-6.02H25.77v6.02l.808.778H32.7z" />
      </g>
    </svg>
  );
}
